import * as React from "react";
import { FormControlLabel, Radio, RadioGroup, Checkbox } from "@mui/material";
import { useAppContext } from "../../AppContextDef";
import { useLocation, useNavigate } from "react-router-dom";
import { replaceMappingIdsWithVariables } from "../../utils/common";
import useAuthFetch from "../../hooks/useAuthFetch";
import ConfirmBox from "../ConfirmBox";
import toast from "react-hot-toast";

export default function UpdateJourneyConfig() {
  const customFetch = useAuthFetch();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState(null);
  let pathName = location.pathname;

  let createRoute = pathName.includes("create") ? true : false;

  const { journeyConfigRowData } = useAppContext();
  const [templateName, setTemplateName] = React.useState(
    createRoute ? "" : journeyConfigRowData?.templateName
  );
  const [templateId, setTemplateId] = React.useState("");
  const [type, setType] = React.useState(
    createRoute ? "" : journeyConfigRowData?.productType
  );

  const [showProductCode, setShowProductCode] = React.useState(
    createRoute ? false : journeyConfigRowData?.productType === "SINGLE" ? true : false
  )
  const [productCodeType, setProductCodeType] = React.useState(
    createRoute ? "" : journeyConfigRowData?.productCodeType
  );
  const [exactProductCode, setExactProductCode] = React.useState(
    createRoute ? "" : (journeyConfigRowData?.productCodeType === "EXACT" ? journeyConfigRowData?.productCodeValue : "")
  );
  const [productCodeStartingWith, setProductCodeStartingWith] = React.useState(
    createRoute ? [] : (journeyConfigRowData?.productCodeType === "STARTING_WITH" ? (journeyConfigRowData?.productCodeValue?.split(',') || []) : [])
  );
  const [timer, setTimer] = React.useState(
    createRoute ? "" : journeyConfigRowData?.allowedTimeForScript
  );
  const [textMatchPercentage, setTextMatchPercentage] = React.useState(
    createRoute ? "" : journeyConfigRowData?.textMatchPercentage
  );
  const [templates, setTemplates] = React.useState([]);
  const [clientScript, setClientScript] = React.useState(
    createRoute ? "" : journeyConfigRowData?.clientScript
  );
  const [clientScriptFemale, setClientScriptFemale] = React.useState(
    createRoute ? "" : journeyConfigRowData?.clientScriptFemale
  );
  const [language, setLanguage] = React.useState(
    createRoute ? "" : journeyConfigRowData?.language
  );
  const [dependentFlag, setDependentFlag] = React.useState(
    createRoute ? "" : journeyConfigRowData?.dependentFlag
  );
  const [policyConfirmationText, setPolicyConfirmationText] = React.useState(
    createRoute ? "" : journeyConfigRowData?.policyConfirmationText
  );
  const [voicePersonalDetail, setVoicePersonalDetail] = React.useState(
    createRoute ? "" : journeyConfigRowData?.voiceoverPersonalDetails
  );
  const [voicePolicyDetail, setVoicePolicyDetail] = React.useState(
    createRoute ? "" : journeyConfigRowData?.voiceoverPolicyDetails
  );
  const [useDifferentScriptForFemale, setUseDifferentScriptForFemale] = React.useState(
    createRoute ? false : journeyConfigRowData?.useDifferentScriptForFemale
  );


  const [errors, setErrors] = React.useState({
    templateName: "",
    type: "",
    productCodeType: "",
    exactProductCode: "",
    productCodeStartingWith: "",
    timer: "",
    clientScript: "",
    language: "",
    policyConfirmationText: "",
    voicePersonalDetail: "",
    voicePolicyDetail: "",
    textMatchPercentage: "",
    useDifferentScriptForFemale: "",
    clientScriptFemale: "",
    dependentFlag: ""
  });

  const languages = [
    "English",
    "Hindi",
    "Marathi",
    "Gujarati",
    "Bengali",
    "Punjabi",
    "Kannada",
    "Tamil",
    "Telugu",
    "Malayalam",
    "Odia",
    "Assamese"
  ];

  const validateFields = () => {
    const newErrors = {};

    // Validate template name for new templates
    if (createRoute && templateButtonType === "new") {
      if (!templateName || !templateName.trim()) {
        newErrors.templateName = "Template name is required when creating a new template.";
      } else if (!/^[a-zA-Z0-9_-]{1,50}$/.test(templateName.trim())) {
        newErrors.templateName =
          "Template name can only contain alphabets, numbers, '_' or '-' and must be at most 50 characters.";
      }
    } else if (createRoute && templateButtonType === "existing") {
      if (!templateId?.trim()) {
        newErrors.templateId = "Please select an existing template.";
      }
    } else if (createRoute && !templateButtonType) {
      // User hasn't selected new or existing yet
      newErrors.templateName = "Please choose to create a new template or select an existing one.";
    } else if (!createRoute) {
      // For edit mode, validate template name format if it exists
      if (templateName && !/^[a-zA-Z0-9_-]{1,50}$/.test(templateName.trim())) {
        newErrors.templateName =
          "Template name can only contain alphabets, numbers, '_' or '-' and must be at most 50 characters.";
      }
    }

    if (templateButtonType === "existing" && !templateId?.trim()) {
      newErrors.templateId = "Template ID is required.";
    }

    if (!type?.trim()) {
      newErrors.type = "Product Type is required.";
    }

    if (showProductCode && !productCodeType?.trim()) {
      newErrors.productCodeType = "Product Code selection is required for Single Product Type";
    }

    if (showProductCode && productCodeType === "EXACT") {
      if (!exactProductCode?.trim()) {
        newErrors.exactProductCode = "Exact Product Code is required";
      } else if (!/^[A-Z0-9]{1,10}$/.test(exactProductCode.trim().toUpperCase())) {
        newErrors.exactProductCode = "Product Code must be alphanumeric and 1-10 characters";
      }
    }

    if (showProductCode && productCodeType === "STARTING_WITH") {
      if (!productCodeStartingWith || productCodeStartingWith.length === 0) {
        newErrors.productCodeStartingWith = "At least one Product Code Starting With option must be selected";
      }
    }

    if (!timer || isNaN(timer) || timer <= 0 || timer.toString().length > 2) {
      newErrors.timer = "Timer must be a positive number of atmost 2 digits";
    }

    if (!textMatchPercentage || isNaN(textMatchPercentage) || textMatchPercentage <= 0 || textMatchPercentage > 100) {
      newErrors.textMatchPercentage = "Text Match Percentage must be a positive number between 0 and 100";
    }

    // if (!/^[a-zA-Z0-9\s{}.,-]+$/.test(clientScript)) {
    //   newErrors.clientScript = "Script on Video Consent Page is required and can only include letters, numbers, spaces, '{', '}', '.', ',', and '-'.";
    // }
    if (!clientScript || clientScript.trim() === "") {
      newErrors.clientScript = "Script on Video Consent Page is required.";
    }
    if (useDifferentScriptForFemale && (!clientScriptFemale || clientScriptFemale.trim() === "")) {
      newErrors.clientScriptFemale = "Script on the Video Consent Page for Female is required since you have chosen to configure a separate script for females.";
    }

    if (!dependentFlag?.trim()) {
      newErrors.dependentFlag = "It is required to choose if Life Assured and Proposer are same/different";
    }

    if (!language?.trim()) {
      newErrors.language = "Language is required.";
    }

    // if (!/^[a-zA-Z0-9\s{}.,\-&]+$/.test(policyConfirmationText)) {
    //   newErrors.policyConfirmationText = "Text on Page 3 can only contain alphabets, numbers, spaces, '{' '}', '.', ','  and '&'.";
    // }

    // if (!/^[a-zA-Z0-9\s{}.,-]+$/.test(voicePersonalDetail)) {
    //   newErrors.voicePersonalDetail = "Text read out on Personal Details Page is required and can only contain alphabets, numbers, spaces, '{' '}', '.', ','  and '-'.";
    // }
    if (!voicePersonalDetail || voicePersonalDetail.trim() === "") {
      newErrors.voicePersonalDetail = "Text read out on Personal Details Page is required.";
    }
    // if (!/^[a-zA-Z0-9\s{}.,-]+$/.test(voicePolicyDetail)) {
    //   newErrors.voicePolicyDetail = "Text read out on Policy Details page is required and can only contain alphabets, numbers, spaces, '{' '}', '.', ','  and -.";
    // }
    if (!voicePolicyDetail || voicePolicyDetail.trim() === "") {
      newErrors.voicePolicyDetail = "Text read out on Policy Details Page is required.";
    }


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [templateButtonType, setTemplateButtonType] = React.useState();
  const [variables, setVariables] = React.useState([]);
  const [selectedVariable, setSelectedVariable] = React.useState("");
  const [focusedTextarea, setFocusedTextarea] = React.useState("");
  const [cursorPosition, setCursorPosition] = React.useState(0);
  const textareaRefs = React.useRef({});

  const handleChange = (event) => {
    if (event.target.value === "SINGLE") {
      setShowProductCode(true)
    } else {
      setShowProductCode(false)
      setProductCodeType("")
      setExactProductCode("")
      setProductCodeStartingWith([])
    }
    setType(event.target.value);
  };

  const handleProductCodeTypeChange = (event) => {
    setProductCodeType(event.target.value);
    setExactProductCode("");
    setProductCodeStartingWith([]);
    // Clear product code errors when type changes
    setErrors(prev => ({
      ...prev,
      exactProductCode: "",
      productCodeStartingWith: "",
      productCodeType: ""
    }));
  };

  const handleExactProductCodeChange = (event) => {
    setExactProductCode(event.target.value.toUpperCase());
    // Clear error when user starts typing
    if (errors.exactProductCode) {
      setErrors(prev => ({ ...prev, exactProductCode: "" }));
    }
  };

  const handleProductCodeStartingWithChange = (char) => {
    setProductCodeStartingWith(prev => {
      if (prev.includes(char)) {
        return prev.filter(c => c !== char);
      } else {
        return [...prev, char];
      }
    });
    // Clear error when user changes selection
    if (errors.productCodeStartingWith) {
      setErrors(prev => ({ ...prev, productCodeStartingWith: "" }));
    }
  };

  const productCodeStartingWithOptions = ["A", "D", "E", "G", "I", "M", "T", "U", "X", "Others"];

  const handleDependentChange = (event) => {
    setDependentFlag(event.target.value);
  };

  const fetchVariables = async () => {
    const url = new URL(
      `${process.env.REACT_APP_API_URL}/v1/dashboard/variableMappings/fetchAll?productType=${type}`
    );
    const method = "GET"
    const { response, status, message } = await customFetch(
      url,
      method,
    );


    if (status === 200) {
      setVariables(response);
    } else {
      setOpen(true);
      setErrMsg(message);
      console.log("Error fetching variables");
    }
  };

  const fetchTemplates = async () => {
    const url = new URL(
      `${process.env.REACT_APP_API_URL}/v1/dashboard/template/fetchAll`
    );
    const method = "GET"
    const { response, status } = await customFetch(
      url,
      method,
    );

    if (status === 200) {
      setTemplates(response);
    } else {
      setOpen(true);
      setErrMsg("Error in fetching templates");
    }
  };

  const handleVariableClick = (productName) => {
    setSelectedVariable(productName);

    // Get the textarea element based on the focused field
    const textarea = textareaRefs.current[focusedTextarea];
    if (textarea) {
      const { value } = textarea;

      // Insert the variable at the saved cursor position
      const newText =
        value.substring(0, cursorPosition) +
        `{${productName}}` +
        value.substring(cursorPosition);

      // Update the corresponding state
      if (focusedTextarea === "personal") {
        setVoicePersonalDetail(newText);
      } else if (focusedTextarea === "client") {
        setClientScript(newText);
      } else if (focusedTextarea === "policy") {
        setVoicePolicyDetail(newText);
      } else if (focusedTextarea === "clientFemale") {
        setClientScriptFemale(newText);
      }

      // Move the cursor position to after the inserted variable
      const newCursorPosition = cursorPosition + `{${productName}}`.length;
      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(newCursorPosition, newCursorPosition);
        setCursorPosition(newCursorPosition);
      }, 0);
    }
  };

  const handleCursorUpdate = (e) => {
    setFocusedTextarea(e.target.name);
    setCursorPosition(e.target.selectionStart);
  };

  const replaceVariablesWithMappingIds = (text) => {
    let updatedText = text;
    variables.forEach(({ mappingId, productName }) => {
      const variablePattern = new RegExp(`\\{${productName}\\}`, "g");
      updatedText = updatedText.replace(variablePattern, `{{${mappingId}}}`);
    });

    return updatedText;
  };

  const handleSave = async () => {
    const initialValues = {
      templateId: journeyConfigRowData?.templateId,
      templateName: journeyConfigRowData?.templateName,
      policyConfirmationText: journeyConfigRowData?.policyConfirmationText,
      clientScript: journeyConfigRowData?.clientScript,
      allowedTimeForScript: journeyConfigRowData?.allowedTimeForScript,
      voiceoverPersonalDetails: journeyConfigRowData?.voiceoverPersonalDetails,
      voiceoverPolicyDetails: journeyConfigRowData?.voiceoverPolicyDetails,
      language: journeyConfigRowData?.language,
      productType: journeyConfigRowData?.productType,
      textMatchPercentage: journeyConfigRowData?.textMatchPercentage,
      productCodeType: journeyConfigRowData?.productCodeType,
      productCodeValue: journeyConfigRowData?.productCodeValue,
      useDifferentScriptForFemale: journeyConfigRowData?.useDifferentScriptForFemale,
      clientScriptFemale: journeyConfigRowData?.clientScriptFemale,
      dependentFlag: journeyConfigRowData?.dependentFlag
    };

    const currentValues = {
      templateId,
      templateName: templateName || "", // Ensure templateName is never null
      policyConfirmationText: replaceVariablesWithMappingIds(
        policyConfirmationText
      ),
      clientScript: replaceVariablesWithMappingIds(clientScript),
      allowedTimeForScript: timer,
      voiceoverPersonalDetails:
        replaceVariablesWithMappingIds(voicePersonalDetail),
      voiceoverPolicyDetails: replaceVariablesWithMappingIds(voicePolicyDetail),
      language,
      productType: type,
      textMatchPercentage,
      productCodeType: showProductCode ? productCodeType : null,
      productCodeValue: showProductCode
        ? (productCodeType === "EXACT"
          ? exactProductCode.trim().toUpperCase()
          : productCodeStartingWith.join(','))
        : null,
      dependentFlag,
      useDifferentScriptForFemale,
      clientScriptFemale: useDifferentScriptForFemale ? replaceVariablesWithMappingIds(clientScriptFemale) : null
    };

    const changedFields = Object.entries(currentValues).reduce(
      (acc, [key, value]) => {
        if (
          JSON.stringify(value) !== JSON.stringify(initialValues[key]) &&
          value !== ""
        ) {
          acc[key] = value;
        }
        return acc;
      },
      {}
    );

    // if no fields are changed, do not update
    if (!Object.keys(changedFields).length) {
      return;
    }

    try {
      if (createRoute) {

        const url = new URL(`${process.env.REACT_APP_API_URL}/v1/dashboard/journeyConfig/create`);
        const bodyContent = currentValues
        const method = "POST"

        const { response, status, message } = await customFetch(
          url,
          method,
          bodyContent
        );

        if (status !== 201) {
          setOpen(true);
          const errorMessage = message
            ? message
            : "Something went wrong while creating a template!";
          setErrMsg(errorMessage);

          // Show toast error for better visibility
          toast.error(errorMessage, {
            position: "bottom-right",
            duration: 5000,
          });

          // If error is related to product code, set it in the errors state
          if (message && (message.includes("Product Code") || message.includes("product code"))) {
            if (productCodeType === "EXACT") {
              setErrors(prev => ({ ...prev, exactProductCode: message }));
            } else if (productCodeType === "STARTING_WITH") {
              setErrors(prev => ({ ...prev, productCodeStartingWith: message }));
            }
          }

          console.log("Error updating journey config", response);
        } else {
          // going to previous url
          navigate(-1);
          toast.success("Template Created Succesfully!", {
            position: "bottom-right",
          });
        }
      } else {

        const url = new URL(`${process.env.REACT_APP_API_URL}/v1/dashboard/journeyConfig/update`);
        const method = "POST"
        const bodyContent = { ...changedFields, id: journeyConfigRowData?.configId }
        const { response, status, message } = await customFetch(
          url,
          method,
          bodyContent
        );

        if (status !== 200) {
          setOpen(true);
          const errorMessage = message
            ? message
            : "Something went wrong while updating a template!";
          setErrMsg(errorMessage);

          // Show toast error for better visibility
          toast.error(errorMessage, {
            position: "bottom-right",
            duration: 5000,
          });

          // If error is related to product code, set it in the errors state
          if (message && (message.includes("Product Code") || message.includes("product code"))) {
            if (changedFields.productCodeType === "EXACT" || productCodeType === "EXACT") {
              setErrors(prev => ({ ...prev, exactProductCode: message }));
            } else if (changedFields.productCodeType === "STARTING_WITH" || productCodeType === "STARTING_WITH") {
              setErrors(prev => ({ ...prev, productCodeStartingWith: message }));
            }
          }

          console.log("Error updating journey config", response);
        } else {
          // going to previous url
          navigate(-1);
          toast.success("Template Updated Succesfully!", {
            position: "bottom-right",
          });
        }
      }
    } catch (error) {
      console.error("Error updating configuration:", error);
    }
  };

  React.useEffect(() => {
    async function fetchData() {
      if (type) {
        await fetchVariables();
      }
      await fetchTemplates();
    }

    fetchData();
  }, []);

  React.useEffect(() => {
    async function fetchData() {
      if (type) {
        await fetchVariables();
      }
    }
    fetchData();
  }, [type]);

  // Update state when journeyConfigRowData becomes available (for edit mode)
  React.useEffect(() => {
    if (!createRoute && journeyConfigRowData) {
      setTemplateName(journeyConfigRowData.templateName || "");
      setType(journeyConfigRowData.productType || "");
      setShowProductCode(journeyConfigRowData.productType === "SINGLE");

      // Set product code type and values
      const codeType = journeyConfigRowData.productCodeType || "";
      const codeValue = journeyConfigRowData.productCodeValue || "";

      setProductCodeType(codeType);

      if (codeType === "EXACT") {
        setExactProductCode(codeValue);
        setProductCodeStartingWith([]);
      } else if (codeType === "STARTING_WITH") {
        setExactProductCode("");
        setProductCodeStartingWith(codeValue ? codeValue.split(',').map(c => c.trim()) : []);
      } else {
        setExactProductCode("");
        setProductCodeStartingWith([]);
      }

      setTimer(journeyConfigRowData.allowedTimeForScript || "");
      setTextMatchPercentage(journeyConfigRowData.textMatchPercentage || "");
      setClientScript(journeyConfigRowData.clientScript || "");
      setClientScriptFemale(journeyConfigRowData.clientScriptFemale || "");
      setLanguage(journeyConfigRowData.language || "");
      setDependentFlag(journeyConfigRowData.dependentFlag || "");
      setPolicyConfirmationText(journeyConfigRowData.policyConfirmationText || "");
      setVoicePersonalDetail(journeyConfigRowData.voiceoverPersonalDetails || "");
      setVoicePolicyDetail(journeyConfigRowData.voiceoverPolicyDetails || "");
      setUseDifferentScriptForFemale(journeyConfigRowData.useDifferentScriptForFemale || false);
    }
  }, [journeyConfigRowData, createRoute]);

  React.useEffect(() => {
    if (type && !createRoute) {
      const personalDetails = replaceMappingIdsWithVariables({
        text: journeyConfigRowData?.voiceoverPersonalDetails || "",
        variables: variables,
      });
      const policyDetails = replaceMappingIdsWithVariables({
        text: journeyConfigRowData?.voiceoverPolicyDetails || "",
        variables: variables,
      });

      // Replace mapping IDs in the text
      setVoicePersonalDetail(personalDetails);
      setVoicePolicyDetail(policyDetails);
    }
  }, [type, variables]);

  return (
    <div className="flex flex-col">
      <div
        style={{
          height: `calc(100vh - 140px)`,
          overflowY: "auto",
        }}
        className="mx-3 scrollbar-primary"
      >
        <div>
          <div className="flex flex-col">
            <div className="flex items-center">
              <label className="block text-black-150">Template Name</label>
              {templateButtonType === "new" ? (
                <div className="ml-4 px-3 py-1 w-1/5 border border-gray-450 rounded-md">
                  <input
                    type="text"
                    value={templateName}
                    onChange={(e) => setTemplateName(e.target.value)}
                    className="border-none w-full focus:outline-none text-black-150 "
                  />
                </div>
              ) : templateButtonType === "existing" ? (
                <div className="ml-4 w-1/5 ">
                  <select
                    value={templateId}
                    onChange={(e) => {
                      const selectedId = e.target.value;

                      const selectedTemplate = templates.find(
                        (template) => String(template.templateId) === selectedId
                      );

                      if (selectedTemplate) {
                        setTemplateName(selectedTemplate.templateName);
                        setTemplateId(selectedTemplate.templateId);
                      }
                    }}
                    className="px-2 py-1.5 focus:outline-none text-black-150 border border-gray-450 rounded-md w-full"
                  >
                    <option disabled value="">
                      Choose a template
                    </option>
                    {templates.map(({ templateName, templateId }) => (
                      <option key={templateId} value={templateId}>
                        {templateName}
                      </option>
                    ))}
                  </select>
                </div>
              ) : !createRoute ? (
                <div className="ml-4 w-1/5 border border-gray-450 px-3 py-1 rounded text-black-150 text-base">
                  {templateName}
                </div>
              ) : null}
              <button
                className="ml-3 px-2 py-1 rounded-md bg-slate-300"
                onClick={() => setTemplateButtonType("new")}
              >
                Create New
              </button>
              <button
                className="ml-3 px-2 py-1 rounded-md bg-slate-300"
                onClick={() => setTemplateButtonType("existing")}
              >
                Choose from existing template
              </button>
            </div>
            {errors.templateName && (
              <p className="text-red-400 text-sm my-1">{errors.templateName}</p>
            )}
          </div>
          <div className="mt-4 flex flex-col ">
            <div className="flex items-center">
              <label className="block text-black-150">Product Type</label>
              <RadioGroup
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                className="ml-8"
                name="controlled-radio-buttons-group"
                value={type}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="SINGLE"
                  control={<Radio />}
                  label="Single"
                />
                <FormControlLabel
                  value="MULTIPLE"
                  control={<Radio />}
                  label="Multiple"
                />
              </RadioGroup>
            </div>
            {errors.type && (
              <p className="text-red-400 text-sm my-1">{errors.type}</p>
            )}
          </div>
          {showProductCode && <div className="mt-4 flex flex-col ">
            <div className="flex items-center">
              <label className="block text-black-150">Product Code</label>
              <RadioGroup
                row
                aria-labelledby="product-code-type-radio-group"
                className="ml-8"
                name="product-code-type-radio-group"
                value={productCodeType}
                onChange={handleProductCodeTypeChange}
              >
                <FormControlLabel
                  value="EXACT"
                  control={<Radio />}
                  label="Exact Product Code"
                />
                <FormControlLabel
                  value="STARTING_WITH"
                  control={<Radio />}
                  label="Product Code Starting With"
                />
              </RadioGroup>
            </div>
            {errors.productCodeType && (
              <p className="text-red-400 text-sm my-1">{errors.productCodeType}</p>
            )}

            {productCodeType === "EXACT" && (
              <div className="mt-4 ml-0">
                <label className="block text-black-150 mb-2">Product Code</label>
                <input
                  type="text"
                  value={exactProductCode}
                  onChange={handleExactProductCodeChange}
                  placeholder="e.g., T51, T74, UW3, E18"
                  maxLength={10}
                  className="px-3 py-2 border border-gray-450 rounded-md w-1/4"
                />
                {errors.exactProductCode && (
                  <p className="text-red-400 text-sm my-1">{errors.exactProductCode}</p>
                )}
              </div>
            )}

            {productCodeType === "STARTING_WITH" && (
              <div className="mt-4 ml-0">
                <label className="block text-black-150 mb-2">Select Product Code Starting With</label>
                <div className="flex flex-wrap gap-3">
                  {productCodeStartingWithOptions.map((char) => (
                    <FormControlLabel
                      key={char}
                      control={
                        <Checkbox
                          checked={productCodeStartingWith.includes(char)}
                          onChange={() => handleProductCodeStartingWithChange(char)}
                        />
                      }
                      label={char}
                    />
                  ))}
                </div>
                {errors.productCodeStartingWith && (
                  <p className="text-red-400 text-sm my-1">{errors.productCodeStartingWith}</p>
                )}
              </div>
            )}
          </div>}
          <div className="mt-4 flex flex-col ">
            <div className="flex items-center">
              <label className="block text-black-150">For Life Assured and Proposer</label>
              <RadioGroup
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                className="ml-8"
                name="controlled-radio-buttons-group"
                value={dependentFlag}
                onChange={handleDependentChange}
              >
                <FormControlLabel
                  value="N"
                  control={<Radio />}
                  label="Same"
                />
                <FormControlLabel
                  value="Y"
                  control={<Radio />}
                  label="Different"
                />
              </RadioGroup>
            </div>
            {errors.dependentFlag && (
              <p className="text-red-400 text-sm my-1">{errors.dependentFlag}</p>
            )}
          </div>
          <div className="mt-4 flex flex-col">
            <div className="flex items-center">
              <label className="block text-black-150">
                Time For Video Consent in Seconds
              </label>
              <input
                value={timer}
                onChange={(e) => {
                  setTimer(e.target.value);
                }}
                type="number"
                className="ml-4 p-2 text-black border border-gray-450 rounded-md"
              />
            </div>
            {errors.timer && (
              <p className="text-red-400 text-sm my-1">{errors.timer}</p>
            )}
          </div>
          <div className="mt-4 flex flex-col">
            <div className="flex items-center">
              <label className="block text-black-150">
                Text Match Percentage
              </label>
              <input
                value={textMatchPercentage}
                onChange={(e) => {
                  setTextMatchPercentage(e.target.value);
                }}
                type="number"
                className="ml-4 p-2 text-black border border-gray-450 rounded-md"
              />
            </div>
            {errors.textMatchPercentage && (
              <p className="text-red-400 text-sm my-1">{errors.textMatchPercentage}</p>
            )}
          </div>
          <div className="mt-4 flex flex-col">
            <div className="flex items-center">
              <label className="block text-black-150">Language</label>
              <select
                value={language}
                onChange={(e) => {
                  setLanguage(e.target.value);
                }}
                className="ml-4 p-2 text-black border border-gray-450 rounded-md"
              >
                <option disabled value="">
                  Select a language
                </option>
                {languages.map((language, index) => (
                  <option key={index} value={language}>
                    {language}
                  </option>
                ))}
              </select>
              {/* <input
                value={language}
                onChange={(e) => {
                  setLanguage(e.target.value);
                }}
                className="ml-4 p-2 text-black border border-gray-450 rounded-md"
              /> */}
            </div>
            {errors.language && (
              <p className="text-red-400 text-sm my-1">{errors.language}</p>
            )}
          </div>
          <div className="mt-4 flex gap-4">
            <div className="flex flex-col flex-1">
              <div className=" flex flex-col ">
                <label className="block text-black-150">
                  Script on Video Consent Page
                </label>
                <textarea
                  name="client"
                  ref={(el) => (textareaRefs.current.client = el)}
                  rows={3}
                  style={{ resize: "none" }}
                  className="mt-2 w-full border border-gray-450 px-3 p-2 rounded-md"
                  value={clientScript}
                  onFocus={(e) => handleCursorUpdate(e)}
                  onClick={(e) => handleCursorUpdate(e)}
                  onKeyUp={(e) => handleCursorUpdate(e)}
                  onChange={(e) => {
                    setClientScript(e.target.value);
                  }}
                />
                {errors.clientScript && (
                  <p className="text-red-400 text-sm my-1">
                    {errors.clientScript}
                  </p>
                )}
              </div>
              <div className="mt-4 flex flex-row items-center">
                <label className="block text-black-150">
                  Configure different script for female:
                </label>
                <Checkbox
                  onChange={(event) => setUseDifferentScriptForFemale(event.target.checked)}
                  checked={useDifferentScriptForFemale}

                ></Checkbox>
              </div>
              {useDifferentScriptForFemale && <div className="mt-4 flex flex-col ">
                <label className="block text-black-150">
                  Script on Video Consent Page for Female
                </label>
                <textarea
                  name="clientFemale"
                  ref={(el) => (textareaRefs.current.clientFemale = el)}
                  rows={3}
                  style={{ resize: "none" }}
                  className="mt-2 w-full border border-gray-450 px-3 p-2 rounded-md"
                  value={clientScriptFemale}
                  onFocus={(e) => handleCursorUpdate(e)}
                  onClick={(e) => handleCursorUpdate(e)}
                  onKeyUp={(e) => handleCursorUpdate(e)}
                  onChange={(e) => {
                    setClientScriptFemale(e.target.value);
                  }}
                />
                {errors.clientScriptFemale && (
                  <p className="text-red-400 text-sm my-1">
                    {errors.clientScriptFemale}
                  </p>
                )}
              </div>}
              <div className="mt-4 flex flex-col ">
                <label className="block text-black-150">
                  Text on Policy Details Page
                </label>
                <textarea
                  rows={3}
                  style={{ resize: "none" }}
                  className="mt-2 w-full border border-gray-450 px-3 p-2 rounded-md"
                  value={policyConfirmationText}
                  onChange={(e) => {
                    setPolicyConfirmationText(e.target.value);
                  }}
                />
                {errors.policyConfirmationText && (
                  <p className="text-red-400 text-sm my-1">
                    {errors.policyConfirmationText}
                  </p>
                )}
              </div>
              <div className="mt-4 flex flex-col ">
                <label className="block text-black-150">
                  Text read out on Personal Details Page
                </label>
                <textarea
                  name="personal"
                  ref={(el) => (textareaRefs.current.personal = el)}
                  rows={3}
                  style={{ resize: "none" }}
                  className="mt-2 w-full border border-gray-450 px-3 p-2 rounded-md"
                  value={voicePersonalDetail}
                  onFocus={(e) => handleCursorUpdate(e)}
                  onClick={(e) => handleCursorUpdate(e)}
                  onKeyUp={(e) => handleCursorUpdate(e)}
                  onChange={(e) => {
                    setVoicePersonalDetail(e.target.value);
                  }}
                />
                {errors.voicePersonalDetail && (
                  <p className="text-red-400 text-sm my-1">
                    {errors.voicePersonalDetail}
                  </p>
                )}
              </div>
              <div className="mt-4 flex flex-col ">
                <label className="block text-black-150">
                  Text read out on Policy Details page
                </label>
                <textarea
                  name="policy"
                  ref={(el) => (textareaRefs.current.policy = el)}
                  rows={5}
                  style={{ resize: "none" }}
                  className="mt-2 w-full border border-gray-450 px-3 p-2 rounded-md"
                  value={voicePolicyDetail}
                  onFocus={(e) => handleCursorUpdate(e)}
                  onClick={(e) => handleCursorUpdate(e)}
                  onKeyUp={(e) => handleCursorUpdate(e)}
                  onChange={(e) => {
                    setVoicePolicyDetail(e.target.value);
                  }}
                />
                {errors.voicePolicyDetail && (
                  <p className="text-red-400 text-sm my-1">
                    {errors.voicePolicyDetail}
                  </p>
                )}
              </div>
            </div>
            <div className="flex flex-col w-1/4">
              <label className="text-black-150 text-base font-semibold">
                Variables
              </label>
              <button
                value={"{applicationNo}"}
                onClick={() => handleVariableClick("{applicationNo}")}
                className={`border ${selectedVariable === "{applicationNo}"
                  ? "border-purple-350 bg-purple-350 text-white"
                  : "border-gray-450 hover:bg-slate-300 hover:border-slate-300 text-black-150"
                  } px-3 py-1 rounded mt-2 max-w-max`}
              >
                Application Number
              </button>
              {variables.map(({ mappingId, productName }, i) => {
                return (
                  <button
                    key={mappingId}
                    onClick={() => handleVariableClick(productName)}
                    className={`border ${selectedVariable === productName
                      ? "border-purple-350 bg-purple-350 text-white"
                      : "border-gray-450 hover:bg-slate-300 hover:border-slate-300 text-black-150"
                      } px-3 py-1 rounded mt-2 max-w-max`}
                  >
                    {productName}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 flex justify-end px-4">
        <button
          onClick={() => {
            navigate(-1);
          }}
          className="bg-[#F3F4F8] text-black-150 font-semibold px-3.5 py-2 rounded"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            // if (createRoute) {
            //   if (validateFields()) {
            //     handleSave();
            //   }
            // } else {
            //   handleSave();
            // }
            if (validateFields()) {
              handleSave();
            }
          }}
          className="ml-3 bg-purple-350 text-white  font-semibold px-3.5 py-2 rounded"
        >
          Save
        </button>
      </div>
      <ConfirmBox
        open={open}
        setOpen={setOpen}
        buttonText={"Close"}
        text={errMsg ? errMsg : "An error occurred"}
      />
    </div>
  );
}
